module.exports = __webpack_public_path__ + "static/media/president-suite-img.a6339155.jpg";